import React from 'react';

import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const UiTypography = () => {
    document.title = "Linc Quality Hub";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs title="UI Elements" breadcrumbItem="Typography" />
                    <Row>

                        <Col xl={12}>
                            <Card>
                                <CardBody>

                                    <CardTitle>Font</CardTitle>
                                    <h1 style={{ fontWeight: '700' }}>Nunito Sans</h1>
                                    <p style={{ fontSize: '18px' }}>“Lorem ipsum dolor sit amet consectetur adipiscing elit at erat consectetur ultricies sapien facilisi euismod duis mauris a sed quam aliquet dui eros sit lacus vitae ut viverra at praesent.”</p>
                                    <hr />
                                    <p className="card-title-desc mb-2">You can use this class name for custom headlines, titles, and paragraphs. Example: <code>.headline, .title, .text</code> </p>


                                    <div className='d-flex gap-3 align-items-center'>
                                        <h1 className="headline">Headline</h1> <code>.headline</code>
                                    </div>
                                    <div className='d-flex gap-3 align-items-center'>
                                        <h1 className="headline-medium">Headline</h1> <code>.headline-medium</code>
                                    </div>
                                    <div className='d-flex gap-3 align-items-center'>
                                        <h1 className="headline-bold">Headline</h1> <code>.headline-bold</code>
                                    </div>

                                    <div className='d-flex gap-3 align-items-center mt-3'>
                                        <h4 className="title">Sub Title</h4> <code>.title</code>
                                    </div>
                                    <div className='d-flex gap-3 align-items-center'>
                                        <h4 className="title-medium">Sub Title</h4> <code>.title-medium</code>
                                    </div>
                                    <div className='d-flex gap-3 align-items-center '>
                                        <h4 className="title-bold">Sub Title</h4> <code>.title-bold</code>
                                    </div>

                                    <div className='d-flex gap-3 align-items-center mt-3'>
                                        <p className="text mb-2">Text</p> <code>.text</code>
                                    </div>
                                    <div className='d-flex gap-3 align-items-center'>
                                        <p className="text-medium mb-2">Text</p> <code>.text-medium</code>
                                    </div>
                                    <div className='d-flex gap-3 align-items-center '>
                                        <p className="text-bold ">Text</p> <code>.text-bold</code>
                                    </div>

                                    <div className="mt-3 border">
                                        <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                                            <code>
                                                {`
     <h1 className="headline">Headline</h1>
     <h1 className="headline-medium">Headline</h1>
     <h1 className="headline-bold">Headline</h1>
    
     <h4 className="title">Title</h4>
     <h4 className="title-medium">Title</h4>
     <h4 className="title-bold">Title</h4>

     <p className="text">Text</p>
     <p className="text-medium">Text</p>
     <p className="text-bold">Text</p>

                        `}

                                            </code>
                                        </pre>
                                    </div>
                                </CardBody>
                            </Card>

                        </Col>

                        <Col xl={12}>
                            <Card>
                                <CardBody>

                                    <h1 style={{ fontWeight: '700' }}>Headings</h1>

                                    <p className="card-title-desc mb-2">You can use <code> h1, h2 tags </code> class name for Regular headings.</p>

                                    <div className='d-flex gap-5' >
                                        <div>
                                            <div className='d-flex gap-3 align-items-center mb-2'>
                                                <h1>Heading 1</h1> <small>42px / Regular</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center mb-2'>
                                                <h2>Heading 2</h2> <small>32px / Regular</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center mb-2'>
                                                <h3>Heading 3</h3> <small>24px / Regular</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center mb-2'>
                                                <h4>Heading 4</h4> <small>22px / Regular</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center mb-2'>
                                                <h5>Heading 5</h5> <small>18px / Regular</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center mb-2'>
                                                <h6>Heading 6</h6> <small>16px / Regular</small>
                                            </div>
                                        </div>

                                        <div className="mt-3 border">
                                            <pre className="mb-0 px-4" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                                                <code>
                                                    {`
<h1 className="semibold">Heading 1</h1>
<h2 className="semibold">Heading 2</h2>
<h3 className="semibold">Heading 3</h3> 
<h4 className="semibold">Heading 4</h4>
<h5 className="semibold">Heading 5</h5>
<h6 className="semibold">Heading 6</h6>
    `}
                                                </code>
                                            </pre>
                                        </div>
                                    </div>






                                    <hr />

                                    <p className="card-title-desc mb-2">You can use <code>.semibold </code> class name for Semibold headings.</p>


                                    <div className='d-flex gap-5' >

                                        <div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <h1 className='semibold mb-2'>Heading 1</h1> <small>42px / Semibold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <h2 className='semibold mb-2'>Heading 2</h2> <small>32px / Semibold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <h3 className='semibold mb-2'>Heading 3</h3> <small>24px / Semibold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <h4 className='semibold mb-2'>Heading 4</h4> <small>22px / Semibold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <h5 className='semibold mb-2'>Heading 5</h5> <small>18px / Semibold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <h6 className='semibold mb-2'>Heading 6</h6> <small>16px / Semibold</small>
                                            </div>
                                        </div>

                                        <div className="mt-3 border">
                                            <pre className="mb-0 px-4" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                                                <code>
                                                    {`
<h1 className="semibold">Heading 1</h1>
<h2 className="semibold">Heading 2</h2>
<h3 className="semibold">Heading 3</h3> 
<h4 className="semibold">Heading 4</h4>
<h5 className="semibold">Heading 5</h5>
<h6 className="semibold">Heading 6</h6>
`}
                                                </code>
                                            </pre>
                                        </div>

                                    </div>





                                    <hr />
                                    <p className="card-title-desc mb-2">You can use <code>.bold </code> class name for bold headings.</p>

                                    <div className='d-flex gap-5' >

                                        <div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <h1 className='bold mb-2'>Heading 1</h1> <small>42px / Bold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <h2 className='bold mb-2'>Heading 2</h2> <small>32px / Bold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <h3 className='bold mb-2'>Heading 3</h3> <small>24px / Bold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <h4 className='bold mb-2'>Heading 4</h4> <small>22px / Bold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <h5 className='bold mb-2'>Heading 5</h5> <small>18px / Bold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <h6 className='bold mb-2'>Heading 6</h6> <small>16px / Bold</small>
                                            </div>
                                        </div>

                                        <div className="mt-3 border">
                                            <pre className="mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                                                <code>
                                                    {`
    <h1 className="bold">Heading 1</h1>
    <h2 className="bold">Heading 2</h2>
    <h3 className="bold">Heading 3</h3> 
    <h4 className="bold">Heading 4</h4>
    <h5 className="bold">Heading 5</h5>
    <h6 className="bold">Heading 6</h6>
    `}
                                                </code>
                                            </pre>
                                        </div>
                                    </div>



                                </CardBody>
                            </Card>

                        </Col>

                        <Col xl={12}>
                            <Card>
                                <CardBody>

                                    <h1 style={{ fontWeight: '700' }}>Special headings</h1>

                                    <p className="card-title-desc mb-2">You can use this class name for custom headlines, titles, and paragraphs. Example: <code>.display1, .display2</code> </p>

                                    <div className='d-flex gap-5' >
                                        <div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <h1 className="display1">Display 1</h1> <small>78px / Bold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <h1 className="display2">Display 2</h1> <small>62px / Bold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <h1 className="display3">Display 3</h1> <small>44px / Bold</small>
                                            </div>

                                            <div className='d-flex gap-3 align-items-center mt-3'>
                                                <h1 className="display4">Display 4</h1> <small>28px / Bold</small>
                                            </div>

                                        </div>
                                        <div className="mt-3 border">
                                        <pre className="mb-0 px-4" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                                            <code>
                                                {`
<h1 className="display1">Display 1</h1>
<h1 className="display2">Display 2</h1>
<h1 className="display3">Display 3</h1>
<h1 className="display4">Display 4</h1>
    `}

                                            </code>
                                        </pre>
                                    </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col xl={12}>
                            <Card>
                                <CardBody>

                                    <h1 style={{ fontWeight: '700' }}> Paragraph</h1>

                                    <p className="card-title-desc mb-2">You can use this class name for diffrent font size. Example: <code>.f-18, .f-16, .f-14</code> </p>

                                    <div className='d-flex gap-5 mt-3 align-items-center' >
                                        <div>
                                            <div className='d-flex gap-3 align-items-center mb-2'>
                                                <p className="f-18">Paragraph</p> <small>18px / Regular</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center mb-2'>
                                                <p className="f-16">Paragraph</p> <small>16px / Regular</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <p className="f-14">Paragraph</p> <small>14px / Regular</small>
                                            </div>
                                            

                                        </div>
                                        <div className=" border">
                                        <pre className="mb-0 px-4" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                                            <code>
                                                {`
<p className="f-18">Paragraph</p>
<p className="f-16">Paragraph</p>
<p className="f-14">Paragraph</p>
    `}

                                            </code>
                                        </pre>
                                    </div>
                                    </div>
                                    

                                    <hr/>
                                    <p className="card-title-desc mb-2">You can use this class name for semi bold paragraph. Example: <code>.f-18 .semibold, .f-16 .semibold, .f-14 .semibold</code> </p>

                                    <div className='d-flex gap-5 mt-3 align-items-center' >
                                        <div>
                                            <div className='d-flex gap-3 align-items-center mb-2'>
                                                <p className="f-18 semibold">Paragraph</p> <small>18px / Semibold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center mb-2'>
                                                <p className="f-16 semibold">Paragraph</p> <small>16px / Semibold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <p className="f-14 semibold">Paragraph</p> <small>14px / Semibold</small>
                                            </div>
                                            

                                        </div>
                                        <div className=" border">
                                        <pre className="mb-0 px-4" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                                            <code>
                                                {`
<p className="f-18 semibold">Paragraph</p>
<p className="f-16 semibold">Paragraph</p>
<p className="f-14 semibold">Paragraph</p>
    `}

                                            </code>
                                        </pre>
                                    </div>
                                    </div>


                                    <hr/>
                                    <p className="card-title-desc mb-2">You can use this class name for bold paragraph. Example: <code>.f-18 .bold, .f-16 .bold, .f-14 .bold</code> </p>

                                    <div className='d-flex gap-5 mt-3 align-items-center' >
                                        <div>
                                            <div className='d-flex gap-3 align-items-center mb-2'>
                                                <p className="f-18 bold">Paragraph</p> <small>18px / Bold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center mb-2'>
                                                <p className="f-16 bold">Paragraph</p> <small>16px / Bold</small>
                                            </div>
                                            <div className='d-flex gap-3 align-items-center'>
                                                <p className="f-14 bold">Paragraph</p> <small>14px / Bold</small>
                                            </div>
                                            

                                        </div>
                                        <div className=" border">
                                        <pre className="mb-0 px-4" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                                            <code>
                                                {`
<p className="f-18 bold">Paragraph</p>
<p className="f-16 bold">Paragraph</p>
<p className="f-14 bold">Paragraph</p>
    `}

                                            </code>
                                        </pre>
                                    </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>


                    
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    );
};

export default UiTypography;